import * as React from "react";

import { IterUtils } from "../../../../../Common/IterableUtils";

import { InlineLabel, ItemLabel, ItemValue, ListItemRoot, ListItemWithMarker } from "./ListItem.styles";

interface ListItemProps {
    width?: number;
    bullet?: boolean;
    dash?: boolean;
    inline?: boolean;
    labelWidth?: number;
    indent?: boolean;
    noPaddings?: boolean;
    label?: string;
    alignLabel?: "top" | "center" | "bottom";
    paddingTop?: number | string;
    paddingBottom?: number | string;
    children: React.ReactNode;
}

export function ListItem(props: ListItemProps): JSX.Element {
    const indentationSpecified = props.indent;
    const indentation = indentationSpecified ? 20 : 0;

    if (props.inline) {
        return (
            <span>
                <InlineLabel>{renderLabelWithLineBreaks(props.label)}</InlineLabel>
                {props.children}
            </span>
        );
    } else if (props.bullet || props.dash) {
        return (
            <ListItemWithMarker indent={indentationSpecified} itemMarker={props.bullet ? "bullet" : "dash"}>
                {props.children}
            </ListItemWithMarker>
        );
    } else {
        const allWidth = props.width ?? 600;
        const labelWidth = props.labelWidth ?? 200;

        return (
            <ListItemRoot
                indent={indentationSpecified}
                paddings={!props.noPaddings}
                width={allWidth - indentation}
                paddingTop={props.paddingTop}
                paddingBottom={props.paddingBottom}>
                {props.label != undefined ? (
                    <>
                        <ItemLabel align={props.alignLabel} width={labelWidth - indentation}>
                            {renderLabelWithLineBreaks(props.label)}
                        </ItemLabel>
                        <ItemValue width={allWidth - labelWidth}>{props.children}</ItemValue>
                    </>
                ) : (
                    props.children
                )}
            </ListItemRoot>
        );
    }
}

function renderLabelWithLineBreaks(label: undefined | string): React.ReactNode[] {
    if (label == undefined) {
        return [];
    }
    const lines = label.split(/<br[ ]*\/>/gi);
    const resultArray: React.ReactNode[] = [];
    for (const [index, line] of IterUtils.iterateEntries(lines)) {
        if (resultArray.length > 0) {
            resultArray.push(<br key={"br_" + index.toString()} />);
        }
        resultArray.push(line);
    }
    return resultArray;
}
